import React, { useState } from "react";
import Fileformat1 from "../../../assest/excel/FileFormat.xlsx";
import Fileformat_other from "../../../assest/excel/FileFormat_other.xlsx";
import { useParams } from "react-router-dom";
import { Domain, Workspace } from "../../../path";
import { useDispatch } from "react-redux";
import { Set_Loader } from "../../../Redux/Action/LoaderAction";
import { toast } from "react-toastify";
import { useEffect } from "react";

const Fileupload = ({ setModalbox, Childlist }) => {
  const { school_id, class_id } = useParams();
  const Dispatch = useDispatch();
  const [FileData, setFileData] = useState(null);
  const Closemodal = () => {
    setModalbox((prev) => ({ ...prev, uploadchild: false }));
    setFileData(null);
  };
  const UploadHandler = (e) => {
    let file = e.target.files[0];
    let file_extension = e.target.files[0]?.name?.split(".")?.pop();
    if (file != undefined || file != "") {
      if (file_extension == "xlsx") {
        setFileData(file);
      } else {
        toast.warn("Kindly upload .xlsx format");
        toast.clearWaitingQueue();
      }
    }
  };
  const SubmitApi = () => {
    if (FileData) {
      Post_Excel();
    } else {
      toast.warn("Kindly upload file");
      toast.clearWaitingQueue();
    }
  };
  const Post_Excel = () => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${localStorage?.getItem("TEACHER_TOKEN")}`
    );

    var formdata = new FormData();
    formdata.append("school_id", atob(school_id));
    formdata.append("class_id", atob(class_id));
    formdata.append("excel_data", FileData, "sudhakar");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    Dispatch(Set_Loader(true));
    fetch(
      `${Workspace[Domain].API_Path}/${
        atob(class_id) == "other"
          ? "upload_other_child_list"
          : "upload_class_child_list"
      }`,
      requestOptions
    )
      .then((r) => r.json().then((data) => ({ status: r.status, body: data })))
      .then((obj) => {
        switch (obj.status) {
          case 200:
            Childlist();
            Dispatch(Set_Loader(false));
            Closemodal();
            toast.success("Uploaded successfully");
            toast.clearWaitingQueue();
            break;
          case 400:
            Dispatch(Set_Loader(false));
            toast.warn(obj.body.message);
            toast.clearWaitingQueue();
          default:
            Dispatch(Set_Loader(false));
            break;
        }
      })
      .catch((error) => {
        Dispatch(Set_Loader(false));
        toast.error("Try again ! something went wrong ");
        toast.clearWaitingQueue();
      });
  };
  useEffect(() => {
    return () => {
      setFileData(null);
    };
  }, []);

  return (
    <div className="fixed w-full h-[100%] top-0 left-0 backdrop-blur-sm bg-[#00000061] flex justify-center items-center">
      <div className="w-[27%] bg-[white] p-3 rounded max-[700px]:w-[95%]">
        <div className="flex items-center justify-between">
          <h3 className="text-center font-semibold text-xl">Upload list</h3>
          <button onClick={Closemodal}>
            <i className="pi pi-times"></i>
          </button>
        </div>

        <input
          type="file"
          name="file upload "
          accept=".xlsx"
          className="hidden"
          id="child-file-upload"
          onChange={UploadHandler}
        />
        <label
          htmlFor="child-file-upload"
          className="flex items-center justify-center flex-col my-5 bg-[#fff0db] p-3 rounded cursor-pointer opacity-[0.7]"
        >
          <p className="text-5xl text-[#f79221] ">
            <i className="fa-solid fa-upload"></i>
          </p>
          <p className="text-[#f79221] font-semibold mt-3 text-sm">
            click to Upload file
          </p>
        </label>
        <p className="font-semibold my-2 text-xs ml-3">{FileData?.name}</p>
        <div className="flex items-center justify-center max-[600px]:flex-col-reverse">
          <button
            className="my-2 py-2 bg-[#ff6868] text-[white] font-semibold rounded w-full mx-2 text-sm"
            onClick={Closemodal}
          >
            Close
          </button>
          <button
            onClick={SubmitApi}
            className="my-2 py-2 bg-[#3cac56] text-[white] font-semibold rounded w-full mx-2 text-sm"
          >
            Submit
          </button>
        </div>

        <div className="mt-10">
          <p className="text-center font-semibold text-xs text-[#0008]">
            *Download sample format
          </p>

          <a
            href={atob(class_id) == "other" ? Fileformat_other : Fileformat1}
            download
            className="bg-[#2da3dc] mx-auto block my-2 text-center text-[white] text-sm font-semibold px-3 py-2 rounded"
          >
            <i className="fa-solid fa-download"></i> Download
          </a>
        </div>
      </div>
    </div>
  );
};

export default Fileupload;
